// src/components/MissingBankDetailsModal.jsx
export default function MissingBankDetailsModal({ show, onClose, list, districtName }) {
  if (!show) return null;

  return (
    <div style={{
      position: "fixed", inset: 0, background: "rgba(0,0,0,0.85)",
      display: "flex", justifyContent: "center", alignItems: "center", zIndex: 99999
    }}>
      <div style={{
        background: "white", width: "820px", maxHeight: "85vh", borderRadius: "12px",
        overflow: "hidden", fontFamily: "Arial", boxShadow: "0 0 40px rgba(0,0,0,0.7)"
      }}>
        <div style={{ background: "#333", color: "white", padding: "18px", textAlign: "center", fontSize: "19px", fontWeight: "bold" }}>
          Bank Details are required to close for month
        </div>

        <div style={{ padding: "20px", maxHeight: "60vh", overflowY: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "15px" }}>
            <thead>
              <tr class="tableheader">
                <th>S.No</th>
                <th>District</th>
                <th>FpsId</th>
                <th>Remarks</th>
              </tr>
            </thead>
            <tbody>
              {list.length === 0 ? (
                <tr><td colSpan="4" style={{ textAlign: "center", padding: "10px" }}>No records</td></tr>
              ) : (
                list.map((item, i) => (
                  <tr key={item.fpsid} style={{ textAlign: "center", height: "42px" }}>
                    <td>{i + 1}</td>
                    <td>{districtName}</td>
                    <td>{item.fpsid}</td>
                    <td>Bank Details Missing</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        <div style={{ textAlign: "center", padding: "20px", background: "#f0f0f0" }}>
          <button onClick={onClose}
            className="button button2" >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}